import React from 'react';
import {
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';

const ActiveCameraGrid = ({ cameras, onWatchLive, loadingCameraId }) => {
  if (!cameras.length) {
    return (
      <Box
        sx={{
          py: 6,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 1.5,
          textAlign: 'center',
        }}
      >
        <VideocamIconPlaceholder />
        <Typography variant="body2" color="text.secondary">
          No cameras online at the moment. Check camera settings or bring a stream online.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(1, minmax(0, 1fr))', sm: 'repeat(2, minmax(0, 1fr))' },
        gap: 2,
        mt: 2,
      }}
    >
      {cameras.map((camera) => {
        const isBusy = loadingCameraId === camera.id;
        return (
          <Card
            key={camera.id}
            sx={{
              borderRadius: 2,
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle1" fontWeight={600}>
                {camera.name || `Camera ${camera.id}`}
              </Typography>
              <Chip label="Online" size="small" color="success" sx={{ borderRadius: 1 }} />
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {camera.location || 'Location not specified'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Last heartbeat: {camera.lastPing ? new Date(camera.lastPing).toLocaleString() : 'No heartbeat yet'}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
              <Button
                variant="contained"
                size="small"
                onClick={() => onWatchLive(camera)}
                disabled={isBusy}
                startIcon={isBusy ? <CircularProgress size={14} color="inherit" /> : undefined}
              >
                Watch live
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => window.open(`/cameras?cameraId=${camera.id}`, '_blank')}
              >
                View details
              </Button>
            </Stack>
          </Card>
        );
      })}
    </Box>
  );
};

const VideocamIconPlaceholder = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <VideocamIcon color="disabled" sx={{ fontSize: 42 }} />
  </Box>
);

export default ActiveCameraGrid;
